export default (name, domain = "") => {
    if (window && window.document) {
        const domainPart = domain ? `;domain=${domain}` : "";
        document.cookie = `${name}=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT${domainPart}`;
    }
};
